module.exports = __webpack_public_path__ + "static/media/UERRELogoButton.f1f97b61.svg";